export default "__VITE_ASSET__b7d2495a__"